import ACYWidget from './component'

export default ACYWidget
